import React, { lazy } from 'react';
export function CalculatorVideo() {
  return <div className="aspect-video w-full bg-gray-100 rounded-lg overflow-hidden shadow-md border border-gray-200" data-id="element-87">
      <div style={{
      position: 'relative',
      paddingTop: '56.25%'
    }} data-id="element-88">
        <iframe src="https://iframe.mediadelivery.net/embed/469465/60ca0f0b-ec59-47be-947d-4a9842046f1a?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
        border: 0,
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '100%'
      }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-89"></iframe>
      </div>
    </div>;
}